export default "__VITE_ASSET__BhEkPBtw__"